(function () {
  const DENY = [/^\/cart/, /^\/checkout/, /^\/account/, /^\/policies/];
  if (DENY.some(rx => rx.test(location.pathname))) return;

  const KEY = 'scroll:' + location.pathname + location.search;
  const MAX_AGE_MS = 10 * 60 * 1000; // 10 min

  const save = () => {
    try {
      sessionStorage.setItem(KEY, JSON.stringify({
        x: scrollX,
        y: scrollY,
        t: Date.now()
      }));
    } catch (_) {}
  };

  addEventListener('pagehide', save, { passive: true });
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'hidden') save();
  }, { passive: true });

  addEventListener('pageshow', (e) => {
    let data;
    try {
      const raw = sessionStorage.getItem(KEY);
      if (!raw) return;
      data = JSON.parse(raw) || {};
    } catch (_) { return; }

    if (!data.t || Date.now() - data.t > MAX_AGE_MS) {
      sessionStorage.removeItem(KEY);
      return;
    }

    const { x = 0, y = 0 } = data;

    const tryRestore = () => {
      const maxY = Math.max(
        0,
        document.documentElement.scrollHeight - window.innerHeight
      );
      const targetY = Math.min(y, maxY);

      if (targetY > 0 ? scrollY !== targetY : scrollY === 0) {
        scrollTo(x, targetY);
      }

      sessionStorage.removeItem(KEY);
    };

    requestAnimationFrame(() => {
      requestAnimationFrame(() => setTimeout(tryRestore, 30));
    });
  }, { passive: true });
})();
